import { render, staticRenderFns } from "./CgmAgp.vue?vue&type=template&id=11b0f606&scoped=true"
import script from "./CgmAgp.vue?vue&type=script&lang=js"
export * from "./CgmAgp.vue?vue&type=script&lang=js"
import style0 from "./CgmAgp.vue?vue&type=style&index=0&id=11b0f606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0f606",
  null
  
)

export default component.exports